import { useState } from "react";
import { Card, CardMedia, Typography, Box, CardActionArea } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tags from "../Tags.js";

export default function FeaturedArticle(props = {}) {
  const {
    article,
    controls,
    fitImage,
    showInfo = true,
    enableTags,
    sx = {},
    sitePath
  } = props

  const navigate = useNavigate()
  const viewArticle = () => {
    if (article.newsWebUrl) {
      window.open(article.newsWebUrl, "_blank", "noopener,noreferrer");
    } else {
      const path = sitePath ? `/${sitePath}/${article.guid}` : article.guid
      navigate(path)
    }
  }

  return <Card
    sx={{ display: 'flex', ...sx }}
    className="featured-article"
  >
    <CardActionArea
      component='div'
      sx={{ display: 'flex' }}
    >
      <div className="article-click-container" onClick={() => viewArticle(article)}>
        <CardMedia component="div" sx={article?.image ? { backgroundImage: `url(${article?.image})` } : undefined} alt="Featured Article" className={"featured-image" + (fitImage ? "-fullbleed" : '')} />
        <CardMedia component="div" sx={article?.image ? { backgroundImage: `url(${article?.image})` } : undefined} alt="Featured Article" className="featured-image-blurred" />

        {showInfo && <div style={{ zIndex: 3 }}>
          <Box className="gradient-overlay">
            <Box className="article-info">
              <div>
                <Typography variant="h6" className="article-title">
                  {article?.title}
                </Typography>
                <Typography variant="body2" className="article-subtitle">
                  {article?.author} • {article?.date}
                </Typography>
              </div>

              <Tags
                tags={article?.tags || ""}
                clickable={enableTags}
                sx={{ marginTop: '4px' }}
                sitePath={sitePath}
              />
            </Box>
          </Box>


        </div>
        }

      </div>
      {controls}
    </CardActionArea>

  </Card>
}